import { TextField } from '@mui/material';
import { MuiTextFieldProps } from '@mui/x-date-pickers/internals/components/PureDateInput';
import { forwardRef } from 'react';
import { useStyles } from './SahinTextField.styles';

type CustomProps = Omit<MuiTextFieldProps, 'error'> & {
  error?: any;
  autocomplete?: string;
};

export const SahinTextField = forwardRef<any, CustomProps>((props, ref) => {
  const { className, error, ...rest } = props;
  const { classes, cx } = useStyles();

  return (
    <>
      <TextField
        {...rest}
        error={!!error}
        helperText={error || rest.helperText}
        color={error ? 'error' : undefined}
        ref={ref}
        className={cx(classes.root, className)}
      />
    </>
  );
});
